// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
* VARIABLES
*/
/*
* MIXINS
*/
.Row__poster {
  position: relative;
  overflow: hidden;
  margin-right: 0.5rem;
  cursor: pointer;
}
.Row__poster:last-of-type img {
  margin-right: 3rem;
}
.Row__poster--wrp {
  display: flex;
  position: relative;
}
.Row__poster--wrp::-webkit-scrollbar {
  display: none;
}
.Row__poster img {
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
  object-position: top;
}
.Row__poster__fallback {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 100%;
  min-height: 150px;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
  z-index: -1;
  padding: 0 1em;
}
.Row__poster--big img {
  width: 100%;
  min-height: auto;
}
.Row__poster-info {
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(15%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding: 0.6em;
  opacity: 0;
  z-index: 2;
  border-radius: 5px;
  pointer-events: none;
  transition: all 0.4s ease 0.15s;
}
@media (min-width: 768px) {
  .Row__poster-info {
    pointer-events: all;
  }
}
.Row__poster-info--iconswrp {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.Row__poster-info--icon {
  display: inline-flex;
  padding: 6px;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;
  margin: 0 5px;
  margin-bottom: 0.6em;
  background: transparent;
  color: #f2f2f2;
  border: 1px solid #f2f2f2;
  transition: all 0.3s ease-out;
  outline: none;
}
@media (min-width: 1024px) {
  .Row__poster-info--icon {
    font-size: 14px;
    padding: 8px;
    margin-bottom: 0.8em;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Row__poster-info--icon {
    font-size: 12px;
    padding: 6px;
    margin-bottom: 0.6em;
  }
}
@media (min-width: 1680px) {
  .Row__poster-info--icon {
    font-size: 14px;
    padding: 8px;
    margin-bottom: 0.8em;
  }
}
.Row__poster-info--icon:hover {
  background: #f2f2f2;
  color: #141414;
}
.Row__poster-info--icon:first-child {
  margin-left: 0;
  background: #f2f2f2;
  color: #141414;
}
.Row__poster-info--icon:first-child:hover {
  background: rgba(242, 242, 242, 0.7);
  border-color: rgba(242, 242, 242, 0.7);
}
.Row__poster-info--title h3 {
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
}
@media (min-width: 1024px) {
  .Row__poster-info--title h3 {
    font-size: 15px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Row__poster-info--title h3 {
    font-size: 12px;
  }
}
@media (min-width: 1680px) {
  .Row__poster-info--title h3 {
    font-size: 15px;
  }
}
.Row__poster-info--title p {
  font-size: 10px;
  margin-top: 0.3vw;
  margin-bottom: 0;
}
@media (min-width: 1024px) {
  .Row__poster-info--title p {
    font-size: 13px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Row__poster-info--title p {
    font-size: 10px;
  }
}
@media (min-width: 1680px) {
  .Row__poster-info--title p {
    font-size: 13px;
  }
}
.Row__poster-info--genres {
  display: block;
  width: 100%;
}
.Row__poster-info--genres .genre-title {
  display: inline-block;
  width: auto;
  font-size: 8px;
  margin: 0 0.3vw 0 0;
}
@media (min-width: 1024px) {
  .Row__poster-info--genres .genre-title {
    font-size: 10px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Row__poster-info--genres .genre-title {
    font-size: 8px;
  }
}
@media (min-width: 1680px) {
  .Row__poster-info--genres .genre-title {
    font-size: 10px;
  }
}
.Row__poster-info--genres .genre-title:after {
  content: "●";
  display: inline-block;
  margin: 0 0 0 0.3vw;
  font-size: 6px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0);
  color: rgba(242, 242, 242, 0.4);
}
.Row__poster-info--genres .genre-title:last-child:after {
  display: none;
}

.swiper-slide .Row__poster::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, transparent 65%);
  z-index: 0;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}
@media (min-width: 768px) {
  .swiper-slide:hover .Row__poster::after {
    opacity: 1;
  }
  .swiper-slide:hover .Row__poster-info {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RowPoster/rowPoster.scss","webpack://./src/scss/_mixin.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;CAAA;AAKA;;CAAA;ADFA;EACC,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAKD;AAFE;EACC,kBAAA;AAIH;AAAC;EACC,aAAA;EACA,kBAAA;AAEF;AAAE;EACC,aAAA;AAEH;AAEC;EACC,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAAF;AAGC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AADF;AAKE;EACC,WAAA;EACA,gBAAA;AAHH;AAOC;EACC,kBAAA;EACA,OAAA;EACA,SAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACM,kBAAA;EACN,oBAAA;EACA,+BAAA;AALF;ACOQ;EDlBP;IAmBE,mBAAA;EAJD;AACF;AAME;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAJH;AAOE;EACC,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,cE/FK;EFgGL,yBAAA;EACA,6BAAA;EACA,aAAA;AALH;ACjBQ;EDUN;IAeE,eAAA;IACA,YAAA;IACA,oBAAA;EAJF;AACF;ACxBQ;EDUN;IAqBE,eAAA;IACA,YAAA;IACA,oBAAA;EAHF;AACF;AC/BQ;EDUN;IA2BE,eAAA;IACA,YAAA;IACA,oBAAA;EAFF;AACF;AAIG;EACC,mBEvHI;EFwHJ,cErHI;AFmHR;AAKG;EACC,cAAA;EACA,mBE7HI;EF8HJ,cE3HI;AFwHR;AAKI;EACC,oCAAA;EACA,sCAAA;AAHL;AASG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;AAPJ;ACxDQ;ED4DL;IAME,eAAA;EANH;AACF;AC7DQ;ED4DL;IAUE,eAAA;EALH;AACF;AClEQ;ED4DL;IAcE,eAAA;EAJH;AACF;AAOG;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AC5EQ;ED8EL;IAME,eAAA;EAJH;AACF;ACjFQ;ED8EL;IAUE,eAAA;EAHH;AACF;ACtFQ;ED8EL;IAcE,eAAA;EAFH;AACF;AAME;EACC,cAAA;EACA,WAAA;AAJH;AAMG;EACC,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAJJ;ACrGQ;EDqGL;IAOE,eAAA;EAHH;AACF;AC1GQ;EDqGL;IAWE,cAAA;EAFH;AACF;AC/GQ;EDqGL;IAeE,eAAA;EADH;AACF;AAGI;EACC,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,uCAAA;EACA,+BAAA;AADL;AAII;EACC,aAAA;AAFL;;AAWE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2EAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;AARH;AC7IQ;ED2JJ;IACC,UAAA;EAXH;EAcE;IACC,UAAA;IACA,wBAAA;EAZH;AACF","sourcesContent":["@import \"../../scss/mixin\";\n@import \"../../scss/variables\";\n\n.Row__poster {\n\tposition: relative;\n\toverflow: hidden;\n\tmargin-right: 0.5rem;\n\tcursor: pointer;\n\n\t&:last-of-type {\n\t\timg {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\t}\n\n\t&--wrp {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\timg {\n\t\tdisplay: inline-block;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tborder-radius: 5px;\n\t\tobject-fit: cover;\n\t\tobject-position: top;\n\t}\n\n\t&__fallback {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tmin-width: 100%;\n\t\tmin-height: 150px;\n\t\tborder-radius: 5px;\n\t\ttext-align: center;\n\t\tfont-weight: 500;\n\t\tz-index: -1;\n\t\tpadding: 0 1em;\n\t}\n\n\t&--big {\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\tmin-height: auto;\n\t\t}\n\t}\n\n\t&-info {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\ttransform: translateY(15%);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: flex-end;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tpadding: 0.6em;\n\t\topacity: 0;\n\t\tz-index: 2;\n        border-radius: 5px;\n\t\tpointer-events: none;\n\t\ttransition: all .4s ease .15s;\n\n\t\t@include mq('md') {\n\t\t\tpointer-events: all;\n\t\t}\n\n\t\t&--iconswrp {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t}\n\n\t\t&--icon {\n\t\t\tdisplay: inline-flex;\n\t\t\tpadding: 6px;\n\t\t\tborder-radius: 50%;\n\t\t\tfont-size: 12px;\n\t\t\tcursor: pointer;\n\t\t\tmargin: 0 5px;\n\t\t\tmargin-bottom: 0.6em;\n\t\t\tbackground: transparent;\n\t\t\tcolor: $white;\n\t\t\tborder: 1px solid $white;\n\t\t\ttransition: all 0.3s ease-out;\n\t\t\toutline: none;\n\n\t\t\t@include mq('lg') {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding: 8px;\n\t\t\t\tmargin-bottom: 0.8em;\n\t\t\t}\n\n\t\t\t@include mq(1378px, 1680px) {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tpadding: 6px;\n\t\t\t\tmargin-bottom: 0.6em;\n\t\t\t}\n\n\t\t\t@include mq(1680px) {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding: 8px;\n\t\t\t\tmargin-bottom: 0.8em;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground: $white;\n\t\t\t\tcolor: $black;\n\t\t\t}\n\n\t\t\t&:first-child {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbackground: $white;\n\t\t\t\tcolor: $black;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: rgba($white, 0.7);\n\t\t\t\t\tborder-color: rgba($white, 0.7);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&--title {\n\t\t\th3 {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\ttext-transform: none;\n\n\t\t\t\t@include mq('lg') {\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1378px, 1680px) {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1680px) {\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 10px;\n\t\t\t\tmargin-top: 0.3vw;\n\t\t\t\tmargin-bottom: 0;\n\n\t\t\t\t@include mq('lg') {\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1378px, 1680px) {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1680px) {\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&--genres {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\n\t\t\t.genre-title {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: auto;\n\t\t\t\tfont-size: 8px;\n\t\t\t\tmargin: 0 0.3vw 0 0;\n\n\t\t\t\t@include mq('lg') {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1378px, 1680px) {\n\t\t\t\t\tfont-size: 8px;\n\t\t\t\t}\n\n\t\t\t\t@include mq(1680px) {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"●\";\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tmargin: 0 0 0 0.3vw;\n\t\t\t\t\tfont-size: 6px;\n\t\t\t\t\ttext-shadow: 0 1px 1px rgba(0, 0, 0, 0);\n\t\t\t\t\tcolor: rgba($white, 0.4);\n\t\t\t\t}\n\n\t\t\t\t&:last-child:after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.swiper-slide {\n\t.Row__poster {\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tborder-radius: 5px;\n\t\t\tbackground: linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, transparent 65%);\n\t\t\tz-index: 0;\n\t\t\topacity: 0;\n\t\t\ttransition: opacity 0.2s ease-out;\n\t\t}\n\t}\n\t@include mq('md') {\n\t\t&:hover {\n\t\t\t.Row__poster {\n\t\t\t\t&::after {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\n\t\t\t\t&-info {\n\t\t\t\t\topacity: 1;\n\t\t\t\t\ttransform: translateY(0);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
